import { articles } from "../../../mocks/trendData";

export default function LatestUpdate() {
  const lead = articles[0];
  const rest = articles.slice(1, 5);

  return (
    <section id="latest" className="scroll-mt-20 bg-background-100 py-14 md:py-20">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="mb-8 flex flex-wrap items-end justify-between gap-4">
          <div>
            <span className="inline-flex items-center gap-1.5 rounded-full bg-primary-100 px-3 py-1 text-xs font-semibold text-primary-700">
              <i className="ri-flashlight-line" aria-hidden="true"></i> 编辑部直击
            </span>
            <h2 className="mt-3 font-heading text-2xl font-bold text-foreground-950 md:text-4xl">
              最新动态
            </h2>
            <p className="mt-2 text-sm text-foreground-500 md:text-base">
              编辑部实时跟进的热点动态与深度盘点。
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 gap-4 lg:grid-cols-2">
          {/* 头版 */}
          <article className="group flex flex-col overflow-hidden rounded-2xl border border-background-200 bg-background-50 lg:row-span-1">
            <div className="relative aspect-[16/9] w-full overflow-hidden">
              <img
                src={lead.cover}
                alt={lead.title}
                className="h-full w-full object-cover object-top transition-transform duration-300 group-hover:scale-105"
              />
              <span className="absolute left-3 top-3 rounded-full bg-primary-500 px-3 py-1 text-xs font-medium text-white">
                头条
              </span>
            </div>
            <div className="flex flex-1 flex-col p-4 md:p-6">
              <span className="text-xs font-medium text-primary-700">{lead.category}</span>
              <h3 className="mt-2 font-heading text-xl font-bold leading-snug text-foreground-950 md:text-2xl">
                {lead.title}
              </h3>
              <p className="mt-2 text-sm leading-relaxed text-foreground-600 md:text-base">
                {lead.summary}
              </p>
              <div className="mt-4 flex items-center gap-4 border-t border-background-200 pt-3 text-xs text-foreground-400">
                <span>
                  <i className="ri-calendar-line mr-1" aria-hidden="true"></i> {lead.date}
                </span>
                <span>
                  <i className="ri-eye-line mr-1" aria-hidden="true"></i> {(lead.views / 1000).toFixed(1)}w 阅读
                </span>
              </div>
            </div>
          </article>

          {/* 副条 */}
          <div className="flex flex-col gap-3">
            {rest.map((art) => (
              <article
                key={art.id}
                className="flex flex-col gap-3 rounded-xl border border-background-200 bg-background-50 p-3 sm:flex-row md:p-4"
              >
                <img
                  src={art.cover}
                  alt={art.title}
                  className="h-28 w-full rounded-lg object-cover object-top sm:h-24 sm:w-36"
                />
                <div className="flex min-w-0 flex-1 flex-col">
                  <div className="flex items-center gap-2">
                    <span className="rounded bg-background-200 px-1.5 py-0.5 text-[11px] text-foreground-600">
                      {art.category}
                    </span>
                    <span className="text-[11px] text-foreground-400">{art.date}</span>
                  </div>
                  <h3 className="mt-1.5 font-heading text-sm font-bold leading-snug text-foreground-950 transition-colors group-hover:text-primary-700 md:text-base">
                    {art.title}
                  </h3>
                  <p className="mt-1 hidden flex-1 text-xs leading-relaxed text-foreground-500 sm:block">
                    {art.summary}
                  </p>
                  <div className="mt-2 flex items-center justify-between">
                    <span className="text-[11px] text-foreground-400">
                      <i className="ri-eye-line mr-1" aria-hidden="true"></i>
                      {(art.views / 1000).toFixed(1)}w
                    </span>
                    <button
                      type="button"
                      className="inline-flex cursor-pointer items-center gap-1 text-xs font-medium text-primary-600 hover:text-primary-700"
                    >
                      阅读全文 <i className="ri-arrow-right-line" aria-hidden="true"></i>
                    </button>
                  </div>
                </div>
              </article>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}